<div class="header">
  <spb-logo routerLink="/start" title="Vägval Borgo – Syd"></spb-logo>
  <div class="right">
    <spb-toggle-button/>
    @if (configService.currentUser()) {
      <span>{{ configService.currentUser()!.name }}</span>
      <button [matMenuTriggerFor]="menu" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>
    }
  </div>
</div>

<mat-menu #menu="matMenu">
  <button [routerLink]="[START_ROUTE_PATH]" mat-menu-item>Vägval Borgo – Syd</button>
  <button (click)="configService.reset()" mat-menu-item>Logga ut</button>
</mat-menu>
